import { Div, RefBool, MultipleFilesInput, Snack, Link } from '@tblabs/truffle';
import { PlaylistProvider } from '../Services/PlaylistProvider';
import { SvgButton } from './SvgButton';


export class FilesUploader extends Div
{
    private onUploadStarted: () => void = () => { };
    private onUploadFinished: () => void = () => { };

    public OnUploadStarted(callback: () => void): this
    {
        this.onUploadStarted = callback;
        return this;
    }

    public OnUploadFinished(callback: () => void): this
    {
        this.onUploadFinished = callback;
        return this;
    }

    constructor(_playlistProvider: PlaylistProvider)
    {
        super();

        const showUploader = new RefBool(false);

        this.Append(
            new SvgButton("Add files").WidthPercent(100)
                .OnClick(async () => showUploader.True())
                .Invisible(showUploader),
            new MultipleFilesInput(async (files: File[]) =>
            {
                try
                {
                    new Snack("Upload started", files.length + " files");

                    this.onUploadStarted?.();
                    const uploadedFiles = await _playlistProvider.AddSongs(files);
                    this.onUploadFinished?.();

                    new Snack("Upload finished", uploadedFiles.length + " files uploaded");
                }
                catch (error: any)
                {
                    console.error(error);
                    console.error("More error info can be found in the browser console or storage Exception log.");
                    new Snack("Upload failed", error.message, { autoCloseTimeout: 0 });
                }
                finally
                {
                    showUploader.False();
                }
            }).Visible(showUploader),
            new Link("×")
                .Style(`transform: translate(-16px, -12px); color: red; font-weight: bold; font-size: 20px; cursor: pointer;`)
                .OnClick(() => showUploader.False())
                .Visible(showUploader)
        );
    }
}
